export default "__VITE_ASSET__BCcKTquG__"